export const categories = [
  {
    id: 'reboju',
    name: '热播剧',
    slug: 'reboju',
    icon: 'ri-fire-line',
    description: '全网热播电视剧，每日更新最新剧集',
    count: 128,
  },
  {
    id: 'dianying',
    name: '电影大全',
    slug: 'dianying',
    icon: 'ri-film-line',
    description: '高清电影在线观看，涵盖各类题材',
    count: 356,
  },
  {
    id: 'dongman',
    name: '动漫',
    slug: 'dongman',
    icon: 'ri-ghost-line',
    description: '热门动漫番剧，日本动漫国漫精选',
    count: 89,
  },
  {
    id: 'zongyi',
    name: '综艺',
    slug: 'zongyi',
    icon: 'ri-tv-line',
    description: '热门综艺节目，搞笑真人秀不断更新',
    count: 64,
  },
  {
    id: 'jilupian',
    name: '纪录片',
    slug: 'jilupian',
    icon: 'ri-global-line',
    description: '精品纪录片，探索世界奥秘',
    count: 42,
  },
  {
    id: 'shaoer',
    name: '少儿',
    slug: 'shaoer',
    icon: 'ri-hearts-line',
    description: '儿童动画启蒙教育内容精选',
    count: 31,
  },
];

export const platforms = [
  { id: 'yaojing', name: '妖精视频', slug: 'yaojing' },
  { id: 'taohua', name: '桃花视频', slug: 'taohua' },
  { id: 'pingguo', name: '苹果视频', slug: 'pingguo' },
  { id: 'liulian', name: '榴莲视频', slug: 'liulian' },
  { id: 'douhua', name: '豆花视频', slug: 'douhua' },
];